<template lang="html">
    <div class="previewBSQR-page">
        <Slogan theTitle="财产线索"/>
        <van-cell-group class="ccxs-box" v-for="(item, index) in this.ccxs"
                        :key="index">
            <span class="ccxs-text"  @click="cSqbqccyyzmc(item.cSqdbccyyz)">{{cSqbqccyyzmc(item.cSqdbccyyz)}}</span>
            <van-field
                v-model="item.cclx"
                readonly
                label="财产类型"
            ></van-field>
            <!--<van-field
                    v-if="item.cCclx == 1"
                    v-model="cclx1"
                    readonly
                    label="财产类型"
            ></van-field>
             <van-field
                    v-if="item.cCclx == 2"
                    v-model="cclx2"
                    readonly
                    label="财产类型"
            ></van-field> <van-field
                    v-if="item.cCclx == 3"
                    v-model="cclx3"
                    readonly
                    label="财产类型"
            ></van-field> <van-field
                    v-if="item.cCclx == 4"
                    v-model="cclx4"
                    readonly
                    label="财产类型"
            ></van-field> <van-field
                    v-if="item.cCclx == 5"
                    v-model="cclx5"
                    readonly
                    label="财产类型"
            ></van-field> <van-field
                    v-if="item.cCclx == 6"
                    v-model="cclx6"
                    readonly
                    label="财产类型"
            ></van-field> <van-field
                    v-if="item.cCclx == 7"
                    v-model="cclx7"
                    readonly
                    label="财产类型"
            ></van-field> <van-field
                    v-if="item.cCclx == 8"
                    v-model="cclx8"
                    readonly
                    label="财产类型"
            ></van-field> <van-field
                    v-if="item.cCclx == 9"
                    v-model="cclx9"
                    readonly
                    label="财产类型"
            ></van-field> <van-field
                    v-if="item.cCclx == 10"
                    v-model="cclx10"
                    readonly
                    label="财产类型"
            ></van-field> <van-field
                    v-if="item.cCclx == 255"
                    v-model="cclx11"
                    readonly
                    label="财产类型"
            ></van-field>-->
            <van-field
                    readonly
                    label="财产所有人"
            ></van-field>
            <van-field
                v-model="item.joinText"
                readonly
                label="财产信息"
                @click="toastJointCcxx(item.joinText)"
            ></van-field>
            <!--<van-field
                    v-if="item.cCclx == 1"
                    v-model="jointCcxx"
                    readonly
                    label="财产信息"
                    @click="toastJointCcxx(jointCcxx)"
            ></van-field>
             <van-field
                    v-if="item.cCclx == 2"
                    v-model="jointCcxx2"
                    readonly
                    label="财产信息"
                    @click="toastJointCcxx(jointCcxx2)"
            ></van-field>
            <van-field
                    v-if="item.cCclx == 3"
                    v-model="jointCcxx3"
                    readonly
                    label="财产信息"
                    @click="toastJointCcxx(jointCcxx3)"
            ></van-field>
            <van-field
                    v-if="item.cCclx == 4"
                    v-model="jointCcxx4"
                    readonly
                    label="财产信息"
                    @click="toastJointCcxx(jointCcxx4)"
            ></van-field>
            <van-field
                    v-if="item.cCclx == 5"
                    v-model="jointCcxx5"
                    readonly
                    label="财产信息"
                    @click="toastJointCcxx(jointCcxx5)"
            ></van-field>
            <van-field
                    v-if="item.cCclx == 6"
                    v-model="jointCcxx6"
                    readonly
                    label="财产信息"
                    @click="toastJointCcxx(jointCcxx6)"
            ></van-field>
            <van-field
                    v-if="item.cCclx == 7"
                    v-model="jointCcxx7"
                    readonly
                    label="财产信息"
                    @click="toastJointCcxx(jointCcxx7)"
            ></van-field>
            <van-field
                    v-if="item.cCclx == 8"
                    v-model="jointCcxx8"
                    readonly
                    label="财产信息"
                    @click="toastJointCcxx(jointCcxx8)"
            ></van-field>
             <van-field
                    v-if="item.cCclx == 9"
                    v-model="jointCcxx9"
                    readonly
                    label="财产信息"
                    @click="toastJointCcxx(jointCcxx9)"
            ></van-field>
             <van-field
                    v-if="item.cCclx == 10"
                    v-model="jointCcxx10"
                    readonly
                    label="财产信息"
                    @click="toastJointCcxx(jointCcxx10)"
            ></van-field>
             <van-field
                    v-if="item.cCclx == 255"
                    v-model="jointCcxx11"
                    readonly
                    label="财产信息"
                    @click="toastJointCcxx(jointCcxx11)"
            ></van-field>-->
            <van-field
                    v-model="item.cSqbqccje"
                    readonly
                    label="财产价值(元)"
            ></van-field>
        </van-cell-group>
        <!--<van-field
                v-model="cczjz"
                readonly
                label="财产总价值(元)"
        ></van-field>-->
        <p class="fd-zjz-content">财产总价值：{{cczjz}}元</p>
    </div>
</template>

<script>
    import Slogan from '../../../components/common/slogan'
    import {typeXb, typeSfzjlx, typeCclx, typeBz,typeCar,TDDW,accAdd} from '../../../filters/index'
    import { Toast } from 'vant';

    export default {
        components: {
            Slogan
        },
        data() {
            return {
                ccxs: [],
                cclx1: "",
                cclx2:"",
                cclx3:"",
                cclx4:"",
                cclx5:"",
                cclx6:"",
                cclx7:"",
                cclx8:"",
                cclx9:"",
                cclx10:"",
                cclx11:"",
                jointCcxx:'',
                jointCcxx2:'',
                jointCcxx3:'',
                jointCcxx4:'',
                jointCcxx5:'',
                jointCcxx6:'',
                jointCcxx7:'',
                jointCcxx8:'',
                jointCcxx9:'',
                jointCcxx10:'',
                jointCcxx11:'',
                bz: "",
                cCsyr:"",
            }

        },
        computed: {
            cSqbqccyyzmc() {
                return function (value) {
                    let name = ''
                    let ccsyr = window.sessionStorage.getItem("ccsyrDB")
                    let ccsyrs = JSON.parse(ccsyr)
                    ccsyrs.map((bqbsqrItem) => {
                        if (bqbsqrItem.cDbDsrid === value) {
                            name = bqbsqrItem.cDsrlx == 1 ? bqbsqrItem.cDsrxm : bqbsqrItem.cQymc
                        }
                    })
                    return name
                }
            },
            // 财产总价值
            cczjz() {
                let num = 0
                this.ccxs.map((item) => {
                    num += Number(item.cSqbqccje) * 100
                })
                return (num/100).toFixed(2)
            },
        },
        methods: {
            ccxsValue(value) {
                switch (value.cCclx) {
                    case '1':
                        return `${typeBz(value.cCclxzbz)}：${Number(value.cXjzje) ? Number(value.cXjzje).toFixed(2) : '--'}`
                    case '2':
                        return `${value.cKhhmc} 账号：${value.cYhckzkhzh} ${Number(value.cYhckzckje) ? Number(value.cYhckzckje).toFixed(2) : '--'}${typeBz(value.cCclxzbz)}`
                    case '3':
                        return `${value.cCclxzclpp} ${typeCar(value.cCclxcllx)} 车牌号：${value.cCklxzcldcph}`
                    case '4':
                        return `${value.cCclxfcdz} ${value.cCclxfczh ? '房产证号：' + value.cCclxfczh : ''}`
                    case '5':
                        return `${value.cCclxtdddz} 面积：${value.cCclxtdmj} ${TDDW(value.cYhckzckdw)} ${value.cCclxtddcqzh ? '产权证号：' + value.cCclxtddcqzh : ''}`
                    case '6':
                        return `${value.cCclxzgpdgpmc} ${value.cCclxzgpdcgsl? value.cCclxzgpdcgsl+'股':''} `
                    case '7':
                        return `${value.cCclxzjjdjjmc} ${value.cCclxzjjdjjsl ? value.cCclxzjjdjjsl + '份' : ''}`
                    case '8':
                        return `${value.cCclxzzwdzqmc} ${value.cCclxzzwdzqmz} 元`
                    case '9':
                        return `${value.cCclxzgqdcggs} ${value.cCclxzgqdczbl}%`
                    case '11':
                        return `${value.cSbmc||'--'}`
                    // case '10':
                    //     return `${value.cCclxzswdtszh} ${Number(value.cSqbqccje) ? Number(value.cSqbqccje).toFixed(2) : '--'}`
                    // case '255':
                    //     return value.cMs
                    default:
                        return value.cMs
                }
            },
            getCcxsList() {
                let Id = window.sessionStorage.getItem("dbid")
                this.$axios.get('ssbq/api/ssdb/ccxss' + "?time=" + new Date().getTime() + "&dbid=" + Id).then(res => {
                    this.ccxs = res.data
                    //代码值特殊处理
                    this.ccxs.map(item => {
                        /*if(item.cCclx == 1){
                            this.cclx1 = typeCclx(item.cCclx)
                            this.jointCcxx = `${typeBz(item.cCclxzbz)}：${Number(item.cXjzje) ? Number(item.cXjzje) : ''}`
                        }else if(item.cCclx == 2){
                            this.cclx2 = typeCclx(item.cCclx)
                            this.jointCcxx2 = `${item.cKhhmc} 账号：${item.cYhckzkhzh} ${Number(item.cYhckzckje) ? Number(item.cYhckzckje).toFixed(2) : ''}${typeBz(item.cCclxzbz)}`
                        }else if(item.cCclx == 3){
                            this.cclx3 = typeCclx(item.cCclx)
                            this.jointCcxx3 = `${item.cCclxzclpp} ${typeCar(item.cCclxcllx)} 车牌号：${item.cCklxzcldcph}`
                        }else if(item.cCclx == 4){
                            this.cclx4 = typeCclx(item.cCclx)
                            this.jointCcxx4 = `${item.cCclxfcdz} ${item.cCclxfczh ? '房产证号：' + item.cCclxfczh : ''}`
                        }else if(item.cCclx == 5){
                            this.cclx5 = typeCclx(item.cCclx)
                            this.jointCcxx5 = `${item.cCclxtdddz} 面积：${item.cCclxtdmj} ${TDDW(item.cYhckzckdw)} ${item.cCclxtddcqzh ? '产权证号：' + item.cCclxtddcqzh : ''}`
                        }else if(item.cCclx == 6){
                            this.cclx6 = typeCclx(item.cCclx)
                            this.jointCcxx6 = `${item.cCclxzgpdgpmc} ${item.cCclxzgpdcgsl? item.cCclxzgpdcgsl+'股':''} `
                        }else if(item.cCclx == 7){
                            this.cclx7 = typeCclx(item.cCclx)
                            this.jointCcxx7 = `${item.cCclxzjjdjjmc} ${item.cCclxzjjdjjsl ? item.cCclxzjjdjjsl + '份' : ''}`
                        }else if(item.cCclx == 8){
                            this.cclx8 = typeCclx(item.cCclx)
                            this.jointCcxx8 = `${item.cCclxzzwdzqmc} ${item.cCclxzzwdzqmz} 元`
                        }else if(item.cCclx == 9){
                            this.cclx9 = typeCclx(item.cCclx)
                            this.jointCcxx9 = `${item.cCclxzgqdcggs} ${item.cCclxzgqdczbl}%`
                        }else if(item.cCclx == 10){
                            this.cclx10 = typeCclx(item.cCclx)
                            this.jointCcxx10 = `${item.cCclxzswdtszh} ${Number(item.cSqbqccje) ? Number(item.cSqbqccje).toFixed(2) : ''}`
                        }else if(item.cCclx == 255){
                            this.cclx11 = typeCclx(item.cCclx)
                            this.jointCcxx11 = item.cMs
                        }*/
                        item.cclx=typeCclx(item.cCclx);
                        item.joinText=this.ccxsValue(item);

                        this.bz = typeBz(item.cCclxzbz)
                    })
                  /*  res.data.forEach(temp => {
                        this.cczjz = accAdd(this.cczjz,temp.cSqbqccje);
                    });*/
                })
                this.initColumnsBSQRS()
            },
            initColumnsBSQRS: function () {
                let Id = window.sessionStorage.getItem("dbid")
                let sqrs = JSON.parse(sessionStorage.getItem('dbbsqrList'))
                if(!sqrs){
                    return;
                }
                sqrs.forEach((item) => {
                    let temp = {
                        "keyId": item.cBqDsrid
                    };
                    if (item.cDsrlx == 1) {
                        // 自然人
                        this.cCsyr = item.cDsrxm;
                        temp.text = item.cDsrxm;
                    } else {
                        // 法人 非法人
                        this.cCsyr = item.cQymc;
                        temp.text = item.cQymc;
                    }
                });
                // return this.$axios.get('ssbq/api/ssdb/bsqrs' + "?time=" + new Date().getTime() + "&dbid=" + Id)
                //     .then(res => {
                //         //  window.sessionStorage.setItem("ccsyrDB",JSON.stringify(res.data))
                //         let sqrs = res.data;
                //         sqrs.forEach((item) => {
                //             let temp = {
                //                 "keyId": item.cBqDsrid
                //             };
                //             if (item.cDsrlx == 1) {
                //                 // 自然人
                //                 this.cCsyr = item.cDsrxm;
                //                 temp.text = item.cDsrxm;
                //             } else {
                //                 // 法人 非法人
                //                 this.cCsyr = item.cQymc;
                //                 temp.text = item.cQymc;
                //             }
                //         });
                //     }).catch(() => {

                //     });
            },
            toastJointCcxx(value){
                Toast(value);
            }
        },
        mounted() {
            this.getCcxsList()
        }
    }
</script>

<style lang="less" scoped>
     .ccxs-text{
        position: absolute;
        left: 135px;
        top: 61px;
        color: #333 !important;
        z-index: 99;
        width:210px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        display:inline-block;
    }
    .fd-zjz-content{
        margin-top: -11px;
        padding-right: 18px;
        height: 1.33333rem;
        line-height: 1.33333rem;
        text-align: right;
        background: #fff;
    }
</style>
